import _ from 'lodash'
import cookie from 'cookie'
import fetch from 'isomorphic-fetch'

import { camelizeKeys, snakelizeKeys } from 'utils/format'
import { generateUUID } from 'utils/uuid'

const API_ROOT = '/api/'

const errorHandler = error => {
  // set message if there is a message or detail string
  let message = (_.isString(error.message) && error.message) ||  // {message: '...'}
    (_.isString(error.response.detail) && error.response.detail) ||  // {detail: '...'}
    (_.isArray(error.response) && _.isString(error.response[0]) && error.response[0]) ||  // ['...']
    null

  // if no message string, check if the error is an object of field messages
  const fieldMessages = (!message &&
    _.isPlainObject(error.response) &&
    Object.keys(error.response).length ? error.response : null)

  // if no message string or field messages, set a generic message string
  if (!message && !fieldMessages) {
    message = 'Something bad happened'
  }

  return Promise.reject({
    error: {
      detail: {
        fieldMessages,
        message,
        statusCode: error.statusCode,
      },
      id: generateUUID(),
      severe: error.statusCode === 500 || _.isString(error.message),  // Severe if 500 or a general error message
      type: 'API',
    },
  })
}

export default (endpoint, method = 'get', data = undefined, isJson = true, snakelize = true) => {
  const fullUrl = endpoint.indexOf(API_ROOT) === -1 ? `${API_ROOT}${endpoint}` : endpoint

  const options = {
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
    },
    method: method.toUpperCase(),
    body: data && isJson ? JSON.stringify(snakelize ? snakelizeKeys(data) : data) : data,
  }

  if (method === 'post' || method === 'patch' || method === 'delete') {
    options.headers['X-CSRFToken'] = cookie.parse(document.cookie).csrftoken

    if (isJson) {
      options.headers['Content-Type'] = 'application/json'
    }
  }

  return fetch(fullUrl, options)
    .then(response => {
      if (response.status === 204) {
        return Promise.resolve({ json: {}, response })
      }
      return response.json().then(json => ({ json, response }))
    })
    .then(({ json, response }) => {
      if (!response.ok) {
        return Promise.reject(camelizeKeys({ response: json, statusCode: response.status }))
      }
      return camelizeKeys(json)
    })
    .then(
      response => ({ response }),
      errorHandler
    )
}



/** WEBPACK FOOTER **
 ** ./src/services/api/fetch.js
 **/